import React from 'react';
import styled from 'styled-components';
import { Switch, Route } from 'react-router-dom';
import ChangePassword from './ChangePassword/ChangePassword';
import UpdateEmail from './UpdateEmail/UpdateEmail';
import AccountInformation from './AccountInformation/AccountInformation';

const AccountContainer = styled.div`
    height: 100%;
    width: 100%;
`;

const Container = styled.div`
    display: flex;
    height: 100%;
`;

const ConnectedAccount = () => (
    <Container>
        <AccountContainer>
            <Switch>
                <Route path="/portal/settings/accountInformation">
                    <AccountInformation />
                </Route>
                <Route path="/portal/settings/updateEmail">
                    <UpdateEmail />
                </Route>
                <Route path="/portal/settings/changePassword">
                    <ChangePassword />
                </Route>
            </Switch>
        </AccountContainer>
    </Container>
);

export default ConnectedAccount;
